<template>
    <div class="back">
        <div class="shadowback">
            <em style="align-self:flex-end; font-size:12px; margin-right:5px; opacity:0.5">Выбрать дату приема:</em>
        <table id="calendar2">
            <thead>
                <tr><td></td><td></td><td></td><td></td><td></td>
                    <td colspan="2">
                        <div class="weekday month" v-bind:style="background(6)">
                            <span style="width:100%; font-size:11px">{{selectedMonth}} {{new Date().getFullYear()}}</span> 
                            <button class="btn arrow" @click="chosenMonth('-')"><span class="material-icons" style="vertical-align:middle; font-size:20px">arrow_back_ios</span></button>
                            <button class="btn arrow" @click="chosenMonth('+')"><span class="material-icons" style="vertical-align:middle; font-size:20px">arrow_forward_ios</span></button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td><div class="weekday" v-bind:style="background(0)">Пн</div></td>
                    <td><div class="weekday" v-bind:style="background(1)">Вт</div></td>
                    <td><div class="weekday" v-bind:style="background(2)">Ср</div></td>
                    <td><div class="weekday" v-bind:style="background(3)">Чт</div></td>
                    <td><div class="weekday" v-bind:style="background(4)">Пт</div></td>
                    <td><div class="weekday" v-bind:style="background(5)">Сб</div></td>
                    <td><div class="weekday" v-bind:style="background(6)">Вс</div></td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(week, index) in days" v-bind:index="index" :key="index">
                    <td v-for="(day, indx) in week" v-bind:index="indx" :key="indx">
                        <div class="weekday odays" v-bind:style="background(indx, day)" tabindex="0" @click="chosenDay(day)"> 
                            <template v-if="day !== 0"> {{day}} </template>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'calendar',
    data() {
        return {
            days: this.getCalendar(new Date().getFullYear(), new Date().getMonth()),
            selectedDay: new Date().getDate(),
            selectedMonth: this.getCurrentMonth(),
            selectedYear: new Date().getFullYear(),
        };
    },
    mounted() {
    },
    methods: {
        background(num, day) {
            const percent = num*15;
            const first = 163 - (163-92)*percent/100;
            const second = 44 + (72-44)*percent/100;
            const third = 223 - (223-212)*percent/100;
            const style = { background: 'rgb(' + first + ', ' + second + ', ' + third + ')'};
            if (day === this.$data.selectedDay) {
                style.opacity = '1';
            }
            return style;
        },
        getDay(date) { // получить номер дня недели, от 0 (пн) до 6 (вс)
            let day = date.getDay();
            if (day == 0) day = 7; // сделать воскресенье (0) последним днем
            return day - 1;
        },
        getCalendar(year, mon) {
           // let year = new Date().getFullYear();
           // let mon = new Date().getMonth();
            let d = new Date(year, mon);
            let days = [];
            let week = [];
            let ind = 0;
            let nulls = [];
            for (let i = 0; i < this.getDay(d); i++) {
                nulls.push(0);
            }
            while (d.getMonth() == mon) {
                week.push(d.getDate());
                if (this.getDay(d) % 7 == 6) { // вс, последний день - перевод строки
                    if (ind == 0) {
                        week = nulls.concat(week);
                    }
                    days[ind] = week;
                    ind++;
                    week = [];
                }
                d.setDate(d.getDate() + 1);
            } 
            // добить таблицу пустыми ячейками, если нужно
            // 29 30 31 * * * *
            nulls = [];
            if (this.getDay(d) != 0) {
                for (let i = this.getDay(d); i < 7; i++) {
                nulls.push(0);
                }
            }
            week = week.concat(nulls);
            days[ind] = week;
           return days;
        },
        getNumMonth(str) {
            const month = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
            return month.findIndex(obj => { return obj ? obj === str : null;}) + 1;     //+1 потому что месяцы с нуля
        },
        getCurrentMonth(chMonth) {
            const month = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
            if (chMonth > -1) {
                this.$data.selectedMonth = month[chMonth];
                return month[chMonth];
            }
            return month[new Date().getMonth()];
        },
        chosenMonth(updown) {
            const month = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
            let ind = 0;
            if (updown === '-') {
                for (let i = 0; i < month.length; i++) {
                    if (month[i] ===  this.$data.selectedMonth) {
                        ind = i;
                    } 
                }
                ind--;
                if (ind === -1) {
                    ind = 11;
                }
            } else {
                for (let i = 0; i < month.length; i++) {
                    if (month[i] ===  this.$data.selectedMonth) {
                        ind = i;
                    } 
                }
                ind++;
                if (ind === 12) {
                    ind = 0;
                }
            }
            this.getCurrentMonth(ind);
            this.$data.days = this.getCalendar(this.$data.selectedYear, ind);
        },
        chosenDay(day) {
            if (day !== 0) {
                this.$data.selectedDay = day;
                this.$emit('chooseDay', { day: this.$data.selectedDay, month: this.getNumMonth(this.$data.selectedMonth)});
            }
        }
    },
};
</script>

<style lang="scss" scoped>
    
    .shadowback {
        background: #F2F1F2;
        display: flex;
        flex-direction: column;
        // background: linear-gradient(to right, rgb(163, 44, 223), rgb(92, 72, 212));
    }
    .weekday {
        margin: 2px;
        border-radius: 5px;
        width: 64px;
        height: 32px;
        text-align: center;
        vertical-align: middle;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .odays {
        cursor: pointer;
        opacity: 0.25;
    }
    .month {
        width: 95%;
        display: flex;
        justify-content: space-evenly;
    }
    .arrow {
        width: 25px;
        padding: 0;
        background: rgb(84, 65, 190);
        color: white;
    }
    .odays:hover {
        opacity: 0.5;
    }
</style>